import { Outlet } from 'react-router'
import { BreadcrumbObjectType } from '~/common/generated/apollo-operations'
import { ChartDetailsProvider } from '~/components/charts/ChartDetailsProvider'
import { lazy } from '~/router/lazy'
import { usePivotTableParams } from '~/router/params'
import { RouteObject } from '~/router/types'

export const pivotTableRoute: RouteObject = {
  path: 'pivot/:pivot_table_id',
  Component: PivotTableLayout,
  handle: { objectType: BreadcrumbObjectType.PIVOT_TABLE },
  children: [
    {
      index: true,
      lazy: lazy(() => import('../../views/pivot/[pivot_table_id]/index')),
      handle: { pageType: 'pivotTable', showBackLink: true },
    },
    {
      path: 'settings',
      lazy: lazy(() => import('./PivotTableSettingsController')),
      handle: {
        pageType: 'pivotTableSettings',
        crumb: 'title_bar.pivot_table_settings',
        showLeftNav: false,
        showBackLink: true,
      },
    },
  ],
}

/** Wraps pivot table routes in ChartDetailsProvider (pivot tables are a chart subtype). */
function PivotTableLayout() {
  const { pivot_table_id } = usePivotTableParams()
  return (
    <ChartDetailsProvider chartId={pivot_table_id}>
      <Outlet />
    </ChartDetailsProvider>
  )
}
